import { Lock, KeyRound, ServerCog, CalendarClock } from "lucide-react";
const medidas = [{
  icon: Lock,
  title: "Cifrado de extremo a extremo",
  desc: "Los documentos y datos se cifran tanto en tránsito como en reposo. La información sensible de tus clientes está protegida en cada punto del proceso."
}, {
  icon: KeyRound,
  title: "Autenticación multifactor",
  desc: "El acceso a la plataforma está protegido con MFA y permisos por rol. Cada usuario ve únicamente lo que su rol le permite."
}, {
  icon: ServerCog,
  title: "Infraestructura segura",
  desc: "Almacenamiento en infraestructura diseñada para cumplimiento, con respaldos y controles de acceso documentados conforme a lo que exige la ley."
}, {
  icon: CalendarClock,
  title: "Resguardo por 10 años",
  desc: "Conforme al Art. 18 reformado, los expedientes se conservan durante 10 años. Al término del plazo puedes exportarlos o eliminarlos definitivamente."
}];
export default function SeguridadDatos() {
  return <section data-section-id="REEMPLAZAR" id="seguridad" className="bg-[#020617] text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Tus datos, <span className="text-primary font-mono">protegidos como exige la ley</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Manejas información sensible de tus clientes. Notalia la resguarda con los controles que el marco regulatorio mexicano demanda.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {medidas.map((medida, i) => {
          const Icon = medida.icon;
          return <div key={medida.title} data-index={i} className="p-6 md:p-8 rounded-lg bg-card border border-border hover:border-primary/40 transition-colors flex items-start gap-4">
                <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-default text-lg font-bold text-white mb-2">{medida.title}</h3>
                  <p className="font-default text-sm text-slate-400 leading-relaxed">{medida.desc}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}